module.exports = __webpack_public_path__ + "img/about-02.52d92ed5.jpg";